<div class="d-flex justify-content-center align-items-center" style="min-height: 300px;" *ngIf="loading">
    <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>